import { put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { addUserToTeam, getTeams } from './service';
import { getTeamsSuccessAction, getTeamsFailureAction } from './action';
import { browserHistory } from '../../App';

export function* getTeamsSaga() {
	try {
		const { data }: AxiosResponse = yield getTeams();
		yield put(getTeamsSuccessAction(data.data));
	} catch (e) {
		yield put(getTeamsFailureAction(e as Error));
	}
}

export function* addUserToTeamSaga(action: any) {
	const { team, callback } = action.payload;
	try {
		yield addUserToTeam(team.organizationId);
		browserHistory.push('/awaiting-approve');
	} catch (e) {
		yield put(getTeamsFailureAction(e as Error));
	} finally {
		yield callback();
	}
}
